import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { PublicKey } from "@solana/web3.js";

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const formatCurrency = (value: number, precision: number) => {
  if (value == null || isNaN(value)) return "0.00";
  const safePrecision = isNaN(precision) ? 2 : precision;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: safePrecision,
    maximumFractionDigits: safePrecision,
  }).format(value);
};

/**
 * Validate a Solana wallet address.
 * Returns true if the address is a valid Solana public key.
 */
export const isValidSolanaAddress = (address: string): boolean => {
  if (!address || address.length < 32 || address.length > 44) {
    return false;
  }
  try {
    new PublicKey(address);
    return true;
  } catch {
    return false;
  }
};
